import { j as p } from "../../jsx-runtime-p91LotPX.mjs";
import { GrowTypography as e } from "../Typography/AntTypography.js";
import { formatCurrency as i } from "../utils/number-formatter.js";
function u(r) {
  const {
    amount: o,
    options: t,
    formatOptions: n,
    textProps: m
  } = r;
  return /* @__PURE__ */ p.jsx(e.Text, { ...m, children: i(o, t, n) });
}
export {
  u as GrowCurrencyText
};
//# sourceMappingURL=CurrencyComponent.js.map
